import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CustomerCreatePage } from '../../../features/customers/pages/CustomerCreatePage';
import { usePageTitle } from '../../../lib/hooks';

const customerSearchSchema = z.object({
  contactId: z.string().optional(),
});

export const Route = createFileRoute('/_auth/customers/new')({
  validateSearch: (search) => customerSearchSchema.parse(search),
  component: CustomerCreateRoute,
});

function CustomerCreateRoute() {
  usePageTitle('New Customer');
  return (
    <CustomerCreatePage />
  );
}
